import React, { useState } from 'react';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';

import {
  trackCheckInThirdPartyAuthSuccess,
  trackCheckInThirdPartyAuthError,
} from '../../analytics';

import { ErrorModal } from '../../components/modals';

import { getGoogleUserInfo } from '../../services/api/google';

import { useAttendeeStore } from '../../stores/attendee';

import { getCheckInRedirectUri } from '../../utils';

interface Props {
  eventId: string;
  type: 'sign-up' | 'login' | 'check-in';
  widthInPx: number;
}

const GoogleBtn: React.FC<Props> = (props) => {
  const { eventId, type, widthInPx } = props;

  const { setAttendeeDetails } = useAttendeeStore();

  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleSuccess = async (response: CredentialResponse) => {
    try {
      const userInfo = await getGoogleUserInfo(response.credential ?? '');

      switch (type) {
        case 'check-in':
          setAttendeeDetails({
            attendeeEmail: userInfo.email,
            attendeeName: userInfo.name,
          });

          trackCheckInThirdPartyAuthSuccess('google');

          navigate(getCheckInRedirectUri(eventId));
          break;

        default:
          break;
      }
    } catch (err) {
      handleError(err);
    }
  };

  const handleError = (error?: any) => {
    console.error(error);
    setError(
      "We couldn't authenticate you with Google. Please try again later",
    );
    trackCheckInThirdPartyAuthError('google', error);
  };

  return (
    <React.Fragment>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        theme="filled_black"
        text="continue_with"
        logo_alignment="left"
        width={widthInPx.toString()}
      />

      <ErrorModal
        show={!!error}
        heading="Something went wrong"
        subheading={error}
        isTryAgainBtn
        isContactUs
      />
    </React.Fragment>
  );
};

export default GoogleBtn;
